/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Box } from '@mui/material';
import { FC } from 'react';

const NullElement = () => null;

const SPOT_BOTTOM_RIGHT_EMS_NAME = 'DPSV2_ContentRecommendation_PDP_BottomRight';
export const SpotBottomRight: FC = () => (
	<Box mt={'10px'} height={'100px'}>
		<ContentRecommendation
			id={SPOT_BOTTOM_RIGHT_EMS_NAME}
			properties={{
				emsName: SPOT_BOTTOM_RIGHT_EMS_NAME,
			}}
			loadingElement={<NullElement />}
			withoutFrame
		/>
	</Box>
);
